"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageDisplay = void 0;
var _reactMintl = require("@godaddy/react-mintl");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
const messageCodeMapping = {
  400: 'userInputEmptyErrorText',
  404: 'apiErrorText',
  413: 'userInputLengthErrorText',
  204: 'apiNoResultsText'
};
const MessageDisplay = ({
  code
}) => messageCodeMapping[code] ? /*#__PURE__*/_react.default.createElement("div", {
  className: "message-display text-center"
}, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
  id: messageCodeMapping[code]
})) : null;
exports.MessageDisplay = MessageDisplay;
MessageDisplay.propTypes = {
  code: _propTypes.default.number
};